import { render, staticRenderFns } from "./estadisticasClientes.vue?vue&type=template&id=6c8e8c3b&scoped=true"
import script from "./estadisticasClientes.vue?vue&type=script&lang=js"
export * from "./estadisticasClientes.vue?vue&type=script&lang=js"
import style0 from "./estadisticasClientes.vue?vue&type=style&index=0&id=6c8e8c3b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c8e8c3b",
  null
  
)

export default component.exports